//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';

    angular.module('container.widgets')
        .directive('srsngBusyIndicator', busyIndicator);

    function busyIndicator() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/busy-indicator/busy-indicator.html',
            scope: {
            },
            controller: controller,
            link: link

        };

        function controller($scope) {
            // this is intentional override
        }

        function link(scope, element, attrs) {

            var color = attrs.color || 'default';
            var size = attrs.size || 'small';

            scope.clazz = color + ' ' + size;
        }
    }

})();

